/**
 * @generated SignedSource<<4d731b1426c2a740d63ea9ddf654a490>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type BackgroundThemeEnum = "default" | "light";
export type JobStatus = "closed" | "deleted" | "draft" | "importing" | "opened";
import { FragmentRefs } from "relay-runtime";
export type JobHeader_Job$data = {
  readonly firm: {
    readonly backgroundTheme: BackgroundThemeEnum | null | undefined;
    readonly logoUrl: string | null | undefined;
    readonly name: string | null | undefined;
    readonly self: boolean | null | undefined;
    readonly slug: string | null | undefined;
  } | null | undefined;
  readonly incognito: boolean | null | undefined;
  readonly jobApplication: {
    readonly " $fragmentSpreads": FragmentRefs<"JobHeader_JobApplication">;
  } | null | undefined;
  readonly jobStatus: JobStatus | null | undefined;
  readonly title: string;
  readonly " $fragmentType": "JobHeader_Job";
};
export type JobHeader_Job$key = {
  readonly " $data"?: JobHeader_Job$data;
  readonly " $fragmentSpreads": FragmentRefs<"JobHeader_Job">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobHeader_Job",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "incognito",
      "storageKey": null
    },
    {
      "alias": "jobStatus",
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "JobApplication",
      "kind": "LinkedField",
      "name": "jobApplication",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "JobHeader_JobApplication"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Firm",
      "kind": "LinkedField",
      "name": "firm",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "self",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "logoUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "backgroundTheme",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Job",
  "abstractKey": null
};

(node as any).hash = "b2a78b5b8e99f7c07349a80c6dfe81ef";

export default node;
